import { Injectable } from '@angular/core';
import {Observable, pipe} from 'rxjs';
import { environment } from '../../../environments/environment';
import { RestApi } from 'app/auth/rest.api';
import {filter, map} from 'rxjs/operators';



@Injectable()
export class CryptoDataService {

    private api_encrypString =  'api/Crypto/EncryptString';
    private api_decryptString = 'api/Crypto/DecryptString';

    constructor(private _authHttp: RestApi) { }

    encryptString(value: string) {
        const body = {'value': value};
        return this._authHttp.post(this.api_encrypString, body);
    }

    decryptString(value: string) {
        const body = {'value': value};
        return this._authHttp.post(this.api_decryptString, body).pipe(map( data => data.decryptedPassword)).toPromise();
      }

    encryptStringPromise(value: string) {
        const body = {'value': value};
        return this._authHttp.post(this.api_encrypString, body).pipe(map( data => data.encryptedPassword)).toPromise();
    }
}
